import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateModeInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateModeInfo = useCallback(
		(prevState, stream) => {
			const mode = { ...prevState.mode };
			if (stream['/vehicle/autonomy_state']) {
				const autonomy = getStreamData(stream, '/vehicle/autonomy_state');
				mode.ready = autonomy === 'ready' || autonomy === 'autonomous';
				mode.pause = autonomy === 'pause';
				mode.run = autonomy === 'autonomous';
			}
			return mode;
		},
		[getStreamData],
	);

	return { updateModeInfo };
};
